import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { RedirectLoginOptions, LogoutOptions } from "@auth0/auth0-react";

export const APP_ID = "io.rank5.app";
export const SERVER_ORIGIN = (
  process.env.REACT_APP_SERVER_ORIGIN || window.location.origin
).replace(/\/+$/, "");

export const isNativeApp = Capacitor.isNativePlatform();

export function auth0Domain(): string {
  const domain =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_AUTH0_DOMAIN_PROD
      : process.env.REACT_APP_AUTH0_DOMAIN_DEV;

  if (!domain) {
    throw new Error("Missing Auth0 domain configuration");
  }

  return domain;
}

export function serverUrl(path: string): string {
  return new URL(path.replace(/^\/+/, ""), `${SERVER_ORIGIN}/`).toString();
}

export function publicWebUrl(path: string): string {
  return serverUrl(path);
}

export function socketNamespace(namespace: string): string {
  return serverUrl(namespace);
}

export function auth0CallbackUrl(domain: string): string {
  return `${APP_ID}://${domain}/capacitor/${APP_ID}/callback`;
}

export function auth0LoginOptions(
  domain: string,
  appState?: RedirectLoginOptions["appState"]
): RedirectLoginOptions {
  if (!isNativeApp) {
    return { appState };
  }

  return {
    appState,
    authorizationParams: {
      redirect_uri: auth0CallbackUrl(domain),
    },
    openUrl: async (url: string) => {
      await Browser.open({ url, windowName: "_self" });
    },
  };
}

export function auth0LogoutOptions(domain: string): LogoutOptions {
  if (!isNativeApp) {
    return {
      logoutParams: {
        returnTo: window.location.origin,
      },
    };
  }

  return {
    logoutParams: {
      returnTo: auth0CallbackUrl(domain),
    },
    openUrl: async (url: string) => {
      await Browser.open({ url, windowName: "_self" });
    },
  };
}
